<template>
<div>
    <div class="navbar z-10" :class="{'navbar--open': navOpen}">
        <router-link @click.native="navOpen = false" to="/" class="navbar__link">
            <span class="material-icons">toll</span>Portfolio
        </router-link>
        <router-link @click.native="navOpen = false" to="/coinLookup" class="navbar__link">
            <span class="material-icons">manage_search</span>Coin lookup
        </router-link>
        <router-link @click.native="navOpen = false" to="/trending" class="navbar__link">
            <span class="material-icons">query_stats</span>Trending
        </router-link>
    </div>
    <div class="navbar__top z-10" @click="toggleNav">
        <span class="material-icons menu-icon">menu</span>
    </div>
</div>
</template>

<script>
export default {
    data(){
        return{
            navOpen: false,
        }
    },
    methods:{
        toggleNav(){
            this.navOpen = !this.navOpen
        }
    }
}
</script>